import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorGuideBook = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path fill="#F7A600" d="M7.375 2.75h5.156V11L9.953 8.545 7.375 11V2.75Z" />
    <path
      fill={getTheme(props["data-theme"])}
      d="M5.25 22.063a2.75 2.75 0 0 1-2.75-2.75V4.75A2.75 2.75 0 0 1 5.25 2h12.5a2.75 2.75 0 0 1 2.75 2.75v14.563a2.75 2.75 0 0 1-2.75 2.75H5.25ZM4 19.313c0 .69.56 1.25 1.25 1.25h12.5c.69 0 1.25-.56 1.25-1.25V4.75c0-.69-.56-1.25-1.25-1.25H5.25C4.56 3.5 4 4.06 4 4.75v14.563Z"
    />
  </svg>
);
export default SvgTwoColorGuideBook;
